import React, { useMemo } from 'react';
import { Flex, Form, Select, Tooltip } from 'antd';
import type { SelectProps } from 'antd';
import './AccountSelector.css';
import { CrownOutlined, PlusOutlined } from '@ant-design/icons';
import { TRoleCheckedCompany } from '../../contexts/company/CompanyContext';

export interface Account {
  id: string;
  name: string;
}

interface AccountSelectorProps {
  companies: TRoleCheckedCompany[];
  selectedAccountId: string;
  onChange: (accountId: string) => void;
  size?: SelectProps['size'];
  className?: string;
  style?: React.CSSProperties;
  placeholder?: string;
  showNewOption?: boolean;
  showExtra?: boolean;
}

const AccountSelector: React.FC<AccountSelectorProps> = ({
  companies,
  selectedAccountId,
  onChange,
  size = 'large',
  className = '',
  style,
  placeholder = 'Sélectionner un compte',
  showNewOption = true,
  showExtra = false,
}) => {
  const options = useMemo(() => {
    return [
      ...(showNewOption ? [{ label: <Flex align="center" gap="8px"><PlusOutlined /> Ajouter une entreprise</Flex>, value: 'new' }] : []),
      ...companies.map((company) => ({
        label: (
          <Flex align="center" gap="8px" style={{ textAlign: 'center' }}>
            {company.isSupervisor ?
              <Tooltip title={'Superviseur'}>
                <CrownOutlined style={{ color: '#10b981', fontSize: '18px' }} />
              </Tooltip> :
              null
            }
            {company.name}
          </Flex>
        ),
        value: company.id,
      }))]
  }, [companies]);

  return (
    <Form.Item extra={showExtra ? selectedAccountId : undefined} style={{ margin: 0 }}>
      <Select
        value={selectedAccountId}
        onChange={onChange}
        className={`account-selector ${className}`.trim()}
        style={{ width: '100%', ...style }}
        size={size}
        options={options}
        placeholder={placeholder}
      />
    </Form.Item>
  );
};

export default AccountSelector;
